<template>
  <div class="al">
    <div class="titre">
      Dashboard web d'administration (Personnel de la compagnie)
    </div>
    <div class="title3 md:mt-10 mt-4">
      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          Accessible depuis un ordinateur, il s'agit d'une application web, multi-utilisateurs avec une forte séparation des droits d'utilisateurs.
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          Elle rassemble les fonctionnalités ci-après:
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          ajout et gestion de personnel;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          assignation des droits d'utilisateurs;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          aperçu du portefeuille client;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          configuration avancée des produits (modification des montants, RC, Primes nettes, bonus, réductions, etc)
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          détails des dossiers de chaque utilisateur;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          envoi de SMS groupés aux utilisateurs pour des fins de campagnes ou d'informations;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          visualisation des déclarations de sinistres et affectations;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          traitement des sinistres;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          paiements multiples automatisés des sinistres par Mobile Money et virements;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          remontée des données financières;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          impression des attestations et conditions particulières;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          exportation des données en format excel, pdf
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.titre{
  font-weight: 800;
  font-size: 36px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black
}
.titre1{
  font-weight: 800;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $dev_green;
}
.title3{
  font-weight: 400;
  font-size: 24px;
  line-height: 38.4px;
  color: $black;
}
span{
  font-size: 30px;
  font-weight: bold;
  margin-right: 10px;
}
@media screen and (max-width: 600px){
  .titre{
    font-size: 20px;
  }
  .titre1{
    font-size: 14px;
  }
  .title3, span{
    font-size: 14px;
    line-height: 32px;
  }
}

@media screen and (min-width: 701px) and (max-width: 1024px){
  .titre{
    font-size: 30px;
  }
  .title3{
    font-size: 22px;
  }
  .titre1{
    font-size: 20px;
  }
  .blocc {
    padding: 30px;
  }
}
</style>
